// extracted by mini-css-extract-plugin
export default {"customField":"Input_customField__s2RXC","placeholder":"Input_placeholder__llSCe","dirty":"Input_dirty__TmDB8","disabled":"Input_disabled__Odmhn"};